import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import DownLoadIcon from 'components/icons/DownLoad'
import UploadIcon from 'components/icons/Upload'
import {
  IconWrapper,
  SubTextWrapper,
  TextWrapper,
  Wrapper,
} from 'modules/Drives/DownloadAndUpload/style'
import {
  downloadCandidateList,
  getRoleMetrics,
  uploadResultAPI,
} from 'modules/Drives/actions'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UploadResult from './UploadResultDrawer/index'

const DownlaodUpload = ({
  driveId,
  noNeedRole,
  roleId,
  getCandidateList,
  getGDList,
  driveData,
  fileUpload,
  stage,
  checkType,
  candidateDeatils,
  assessment,
  rolesMetrics,
  setSearchParams,
  searchParams,
  currentTimeDetails,
  currentSelection,
}) => {
  const dispatch = useDispatch()

  const driveRoleList = useSelector(state => state?.drives?.driveRolesMetrics)
  const roundList = useSelector(state => state?.drives?.roleMetrics)
  const [uploadResult, setUploadResult] = useState(false)
  const [isDrawer, setIsDrawer] = useState(false)

  const [selectedRoleId, setSelectedRoleId] = useState(driveRoleList[0]?.roleId)

  const [upload, setUpload] = useState(false)
  const [disable, setDisable] = useState(false)

  const handleDownoload = async () => {}

  const handleUpload = () => {
    setIsDrawer(false)
    setUploadResult(true)
    setUpload(false)
  }

  useEffect(() => {
    setSelectedRoleId(noNeedRole ? roleId : driveRoleList[0]?.roleId)
  }, [driveRoleList, noNeedRole, roleId])

  useEffect(() => {
    if (driveId && selectedRoleId) {
      dispatch(getRoleMetrics(driveId, selectedRoleId))
    }
  }, [driveId, selectedRoleId])

  useEffect(() => {
    setDisable(false)
    if (
      driveData?.driveMode === 'VIRTUAL_DRIVE' &&
      driveData?.corporateStatus === 'CANCELLED'
    ) {
      setDisable(true)
    }
  }, [driveData])

  const content = () => {
    return (
      <Fragment>
        <Wrapper
          onClick={handleDownoload}
          pointer={rolesMetrics?.count === 0}
          opacity={rolesMetrics?.count === 0}
        >
          <Flex>
            <IconWrapper>
              <DownLoadIcon />
            </IconWrapper>
          </Flex>
          <Flex column center>
            <TextWrapper>Download Candidate Lists</TextWrapper>
            <SubTextWrapper>
              Download Candidate List in Excel sheet
            </SubTextWrapper>
          </Flex>
        </Wrapper>
        <div style={{}}>
          <Wrapper
            onClick={handleUpload}
            pointer={rolesMetrics?.count === 0}
            opacity={rolesMetrics?.count === 0}
          >
            <Flex>
              <IconWrapper padding>
                <UploadIcon />
              </IconWrapper>
            </Flex>
            <Flex column center>
              <TextWrapper>Upload Result</TextWrapper>
              <SubTextWrapper>Upload result in Excel sheet</SubTextWrapper>
            </Flex>
          </Wrapper>
        </div>
      </Fragment>
    )
  }

  return (
    <>
      <Button.Secondary
        isBorder={true}
        text={'Bulk Upload'}
        height={'38px'}
        onClick={() => {
          setUploadResult(true)
        }}
        disabled={disable}
      />

      <Drawer
        title={'Download / Upload'}
        placement="right"
        visible={isDrawer}
        content={content()}
        onClose={() => {
          setUploadResult(false)
        }}
        closable
      />

      <UploadResult
        uploadResult={uploadResult}
        setUploadResult={setUploadResult}
        driveRoleList={driveRoleList}
        selectedRoleId={selectedRoleId}
        setSelectedRoleId={setSelectedRoleId}
        roundList={roundList}
        noNeedRole={noNeedRole}
        downloadCandidateList={downloadCandidateList}
        driveId={driveId}
        roleId={roleId}
        uploadResultAPI={uploadResultAPI}
        setIsDrawer={setIsDrawer}
        getCandidateList={getCandidateList}
        getGDList={getGDList}
        getRoleMetrics={getRoleMetrics}
        upload={upload}
        setUpload={setUpload}
        externalAssessment={true}
        fileUpload={fileUpload}
        stage={stage}
        checkType={checkType}
        assessment={assessment}
        rolesMetrics={rolesMetrics}
        setSearchParams={setSearchParams}
        searchParams={searchParams}
        currentTimeDetails={currentTimeDetails}
        currentSelection={currentSelection}
      />
    </>
  )
}

export default DownlaodUpload
